import { browser } from '@openclassrooms/utils';
import isPath from './isPath';

export default function isOnCoursesPage() {
  return isPath(browser.document.location.pathname, '/courses');
}
